import {
  QueryHookOptions,
  useMutation,
  MutationTuple,
  QueryResult,
} from '@apollo/client';

import { DocumentNode } from 'graphql';
import { fieldDefsToFields } from '../../../Utils/columnDefsToFields';
import { Result } from 'true-myth';
import { gql } from '@apollo/client';
import { toString } from 'ramda';
import { INodeData } from '../NodeQuery/NodeQuery';
import { IClientBusinessModel } from '../../../Types/ClientModelTypes';

/** Svar på en node fråga */
interface INodeResultData {
  node: INodeData | null;
}

export interface INodeQueryResult<TData, TNodeData, TVariables>
  extends QueryResult<TData, TVariables> {
  nodeData: TNodeData | null | undefined;
}

const updateMutationString = (collectionName: string, fieldDefs: string[]) =>
  `mutation updateMutation(
  $db: String!
  $values: TEDInput${collectionName}UpdateValues!
) {
  db(name: $db) {
    ${collectionName}_Update(values: $values) {
      id
      __typename
        ${fieldDefsToFields(collectionName)([...fieldDefs])}
    }
  }
}`;

const errormessage = (querystring: string, error: string) =>
  `Fel vid parsning av query:
${querystring}`;

export const makeUpdateQuery = (
  collectionName: string,
  fieldDefs: string[],
  detaljurvalAssociationName?: string,
  associationCollection?: IClientBusinessModel,
  caption?: string
): Result<DocumentNode, string> => {
  let querystring: string;
  querystring = updateMutationString(collectionName, fieldDefs);
  let query;
  try {
    query = gql(querystring);
  } catch (error) {
    return Result.err(errormessage(querystring, toString(error)));
  }
  return Result.ok(query);
};

const useUpdateMutation: <
  TData extends INodeResultData,
  TNodeData extends INodeData,
  TVariables extends { id: string }
>(
  mutation: DocumentNode,
  nodeId: string | null,
  options?: QueryHookOptions<TData, TVariables>
) => MutationTuple<any, any> = (mutation, nodeId, options) => {
  const result = useMutation(mutation);

  return result;
};

export default useUpdateMutation;
